// Site-wide configuration
const config = {
  siteName: "Chandan Gupta",
  siteUrl: "https://chandanprofile.com",
  emailJsServiceId: "YOUR_SERVICE_ID",     // Replace with EmailJS service ID
  emailJsTemplateId: "YOUR_TEMPLATE_ID",   // Replace with EmailJS template ID
  emailJsPublicKey: "YOUR_PUBLIC_KEY",     // Replace with EmailJS public key
  counterBg: "/images/cover_bg_1.jpg",
  recaptchaSiteKey: "",                    // Optional
};

export default config;
